import React from "react";
import { ConsultantQualityCheckDataFragment } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { QualityCheckMeta } from "../quality-check-meta";
import { QualityCheckStatusSetOn } from "../quality-check-status-set-on";
import QualityCheckStatusExpiresOn from "../quality-check-status-expires-on";
import { hasStatusParams } from "../utils";

type Props = {
  data: ConsultantQualityCheckDataFragment;
  showComment?: boolean;
};

export function CriminalRecordLabels({ data, showComment }: Props) {
  const items: React.ReactNode[] = [
    <QualityCheckStatusSetOn key="comment" data={data} showComment={showComment} />,
    <QualityCheckStatusExpiresOn key="exp" data={data} />
  ];

  if (hasStatusParams(data.Status)) {
    const criminalRecordType = data.Status.params.criminalRecordType;

    if (criminalRecordType) {
      items.unshift(
        <QualityCheckMeta
          key="type"
          title={locale.Type}
          description={locale.criminalRecordType[criminalRecordType]}
        />
      );
    }
  }

  return items;
}
